import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEOHead from '../components/SEOHead';
import SplineBackground from '../components/SplineBackground';
import { getNotFoundSplineSceneUrl } from '../config/spline';
import './NotFound.css';

const NotFound = () => {
  const { i18n } = useTranslation();
  const isKa = i18n.language === 'ka';

  return (
    <div className="not-found-page">
      <SEOHead
        title="404 | GFM Studio"
        description={
          isKa
            ? 'გვერდი, რომელსაც ეძებთ, ვერ მოიძებნა.'
            : 'The page you are looking for could not be found.'
        }
        path="/404"
        noindex
      />
      <section className="not-found-section">
        <SplineBackground
          embedded
          sceneUrl={getNotFoundSplineSceneUrl()}
          className="spline-embedded--notfound-bg"
        />
        <div className="not-found-content">
          {/* The Spline scene already renders its own "404 Not Found" 3D
              text, so this heading stays visually hidden (for a11y/SEO)
              instead of duplicating it on screen. */}
          <h1 className="visually-hidden">
            {isKa ? '404 - გვერდი ვერ მოიძებნა' : '404 - Page not found'}
          </h1>
          <p className="not-found-description">
            {isKa
              ? 'გვერდი, რომელსაც ეძებთ, არ არსებობს ან გადატანილია.'
              : "The page you're looking for doesn't exist or has been moved."}
          </p>
          <Link to="/" className="button button-primary button-large not-found-home-link">
            {isKa ? 'მთავარ გვერდზე დაბრუნება' : 'Back to home'}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
